<template>
<b-container>
<b-card>
<b-breadcrumb>
    <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
    <b-breadcrumb-item active>Organizations/Groups</b-breadcrumb-item>
</b-breadcrumb>
<h3>{{ward.ward_name}} Organizations/Groups</h3>

        <b-button class="mb-3" :to="{name: 'ward-organization', params: { wardId: wardId}}" variant="primary"> Create Organization/Group <font-awesome-icon icon="plus" /></b-button>
        <b-row  class="mb-3 mt-3">
            <b-col>
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'search']"/>
      </b-input-group-prepend>
                <b-form-input v-model="searchTerm" placeholder="Search for an organization" @input="delaySearchOrganizations"></b-form-input>
                  </b-input-group>
            </b-col>
        </b-row>
        <b-row>
        <b-col>
        <b-table
            :fields="table.fields"
            :items="table.items"
            :busy="table.isBusy"
            :tbody-tr-class="rowClass"
            class="mb-3"
            light
            responsive
            show-empty
            empty-text="No organizations/groups to show"
            outlined>
            <template v-slot:cell(edit)="row">
                <b-button :key="row.item.uid" :to="{name: 'organization-contacts', params: { wardId: wardId, organizationCode: row.item.org_code}}"  variant="outline-secondary">
                <font-awesome-icon icon="eye" />
                </b-button>
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
        </b-table>
        </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
        <b-button-group v-if="pages.length>1">
            <b-button @click="searchOrganizations(currentPage-1)">Prev</b-button>
            <b-button @click="searchOrganizations(currentPage+1)">Next</b-button>
        </b-button-group>
            </b-col>
        </b-row>
</b-card>
</b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import handleError from "@/errorHandler";
import _ from "lodash";
export default {
    name: "WardOrganizations",
    props: {
        wardId: {
            type: String,
            required: false
        }
    },
    mixins: [],
    data () {
        return {
            ward: {
                ward_name: null,
                ward_city: null
            },
            singlePage: {
                aux_id : null,
                pk_id : null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            searchTerm: null,
            show: false,
            table: {
                id:"organization-list",
                fields: [
                    {
                        key: "org_code",
                        label: "Organization/Group Code"
                    },
                    {
                        key: "org_name",
                        label: "Organization/Group Name"
                    },
                    {
                        key: "edit",
                        label: "View"
                    }

                ],
                items: [],
                isBusy: false
            }
        }
    },
    async mounted() {
        this.show = true;
        this.pages.push(this.singlePage);
        await this.searchOrganizations(0);
        this.show = false;

    },
    methods: {
        async searchOrganizations(page) {
            if (page<0){
                return;
            }
            if (page >this.pages.length-1){
                return;
            }
            const payload = this.pages[page];
            payload.search_term = this.searchTerm;
            this.table.isBusy = true;
            try{
                const { data } = await WardApi.searchWardOrganizations(this.wardId, payload);
                //console.log(data);
                this.ward = data.ward;
                this.table.items = data.org_list.organizations;
                if (data.org_list.last_evaluated_key!==null){
                    if(!this.existInPageList(data.org_list.last_evaluated_key, this.pages))
                        this.pages.push(data.org_list.last_evaluated_key);

                }
                this.currentPage = page;
            } catch (e) {
                const msg = "Error searching for organizations";
                handleError(e, msg);
            } finally {
                this.table.isBusy = false;
            }
        },
        async filterOrganizations(){
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.singlePage);
            await this.searchOrganizations(0);
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;

        },
      delaySearchOrganizations: _.debounce(async function() {
        await this.searchOrganizations(0);
      }, 500),
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.disabled) return 'organization-disabled';
        }
    },


}
</script>
<style lang="scss">
.organization-disabled {
  color: #757575;
  background-color: #f5f5f5 !important;
}
</style>
